import $http from "../../../../../axios-instance";

/**
 * Obtener las SubCategorías asociadas al producto y version.
 *
 * @param Object commit
 * @param Object { productId, versionId }
 * @return void
 */
export async function getSubCategoriesIdsByProduct({ commit }, { productId, versionId }) {
    commit("dashboard/load", true, { root: true });
    try {

        const { data: response } = await $http.get(`/products/sga2/sub-categories-ids`, { params: { productId, versionId } });
        commit('setProdSga2subCategories', response.data);        
        
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Obtener las clases de peligro asociadas al producto.
 *
 * @param Object commit
 * @param Object params -> { productId, versionId, languageId }
 * @return void
 */
export async function getDangerClassesSubCategoriesByProduct({ commit }, params) {
    commit("dashboard/load", true, { root: true });
    try {

        const { data: response } = await $http.get(`/products/sga2/danger-classes`, { params });
        commit('setProductSga2HazardClasses', response.data);        
        
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Guardar SGA productos (Palabra de advertencia, Pictogramas, Sub categorías, Sustancias no peligrosas).
 * 
 * @param Object { commit, dispatch }
 * @param Object payload
 * @return void
 */
export async function storeSga2ToProduct({ commit, dispatch }, payload) {
    commit("dashboard/load", true, { root: true });
    try {
            
        const { data: response } = await $http.post('/products/sga2/store', payload);
        this.$vue.$alertSuccess(response.message);

        dispatch('productSga2pictograms/getPictogramsBySubCategoriesOfProduct', payload, { root: true })
        dispatch('productSga2WordsOfCaution/getSubCategoriesWordOfCautionByProduct', payload, { root: true })

    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}
